// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"381":"d9484603","442":"b347f3e6","453":"220f3d7d","478":"2a4e802b","767":"655da85c","903":"e5b9e80d"}[chunkId] + ".chunk.js";
};